export default __webpack_public_path__ + "static/rmg-logo-with-iso-5e91f62ee10e94b68bd38f6099454b10.png";